import { LoadingOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import useFormInstance from 'antd/lib/form/hooks/useFormInstance';
import { ReactComponent as DownloadIcon } from 'app/assets/img/download.svg';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { CommonText } from 'app/pages/NewAccount/CheckTickets/styled';
import { StyledCheckbox } from 'app/pages/NewAccount/CheckTickets/UpgradeSummary/_TicketExportForm';
import CustomModalContainer from 'app/pages/NewPaymentCallback/PrintTickets/_ModalContainer';
import { downloadSelectedPdfApi } from 'app/services/checkoutApi';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

enum ExportType {
  ZIP = '1',
  PDF = '0',
}

const ApplicationType = ['pdf', 'zip'];

const ExportPdfModal = ({
  form,
  isShowDownload,
}: {
  form: FormInstance;
  isShowDownload: () => boolean;
}) => {
  const [open, setOpen] = useState(false);
  const translations = useSelector(selectTranslations);
  const [exportType, setExportType] = useState(ExportType.ZIP);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const onCloseDialog = () => {
    setOpen(false);
  };

  const listExportOptions = [
    {
      id: ExportType.ZIP,
      name: translations?.['b2b.send-ticket.export-zip'],
    },
    {
      id: ExportType.PDF,
      name: translations?.['b2b.send-ticket.export-pdf'],
    },
  ];

  const handleOpenModal = async () => {
    try {
      await form.validateFields();
    } catch (error) {
      return;
    }
    const _isShowDownload = isShowDownload();
    if (_isShowDownload) {
      setOpen(true);
      form.setFieldValue('isShowDownload', '1');
    } else {
      form.setFieldValue('isShowDownload', '0');
      form?.submit();
    }
  };

  const handleChangeExportType = e => {
    const value = e.target.value;
    setExportType(value);
  };

  const handleDownload = async () => {
    try {
      setOpen(false);
      form?.setFieldValue('isZip', exportType);
      form?.submit();
      setIsLoading(true);
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        style={{
          color: 'white',
          width: '170px',
          height: 48,
          fontWeight: 500,
          fontSize: '14px',
          borderRadius: '10px',
          background:
            'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
        }}
        onClick={handleOpenModal}
      >
        <span
          className="--textBtn"
          style={{
            marginLeft: 8,
          }}
        >
          {translations ? translations['b2c.txt.confirm'] : ''}
        </span>
      </Button>
      {!!errorMsg && (
        <CustomModalContainer
          open={!!errorMsg}
          onCloseDialog={() => setErrorMsg('')}
        >
          {errorMsg}
        </CustomModalContainer>
      )}
      {open && (
        <CustomModalContainer open={open} onCloseDialog={onCloseDialog}>
          <StyledStack direction={'column'} rowGap={'12px'}>
            <CommonText>
              {translations?.['b2b.pdf.choose-send-ticket-type-title']}
            </CommonText>
            <StyledStack direction={'column'} rowGap={'8px'}>
              {listExportOptions.map((i, index) => {
                const value = i?.id;
                return (
                  <StyledCheckbox
                    style={{ borderRadius: '50%', marginLeft: 0 }}
                    key={index}
                    checked={value === exportType}
                    value={value}
                    onChange={handleChangeExportType}
                  >
                    {i?.name}
                  </StyledCheckbox>
                );
              })}
            </StyledStack>
            <StyledButton
              onClick={handleDownload}
              style={{
                marginTop: 12,
                alignSelf: 'center',
                color: 'white',
                backgroundImage: 'linear-gradient(to right, #f06f24, #F8B117)',
              }}
            >
              {translations?.['b2b.btn.confirm']}
            </StyledButton>
          </StyledStack>
        </CustomModalContainer>
      )}
    </>
  );
};

export default ExportPdfModal;
